import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'vodDetails',
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  emptyMessage: "You don't have logs.",
  fields: [
    {
      attributeName: 'pawn',
      label: 'Pawn',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      helpText: 'The pawn that has performed the task.',
    },
    {
      attributeName: 'task',
      label: 'Task',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'The task made by the pound.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'Status of the task.',
    },
    {
      attributeName: 'numErrors',
      label: 'Errors Num',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'Number of errors in this task.',
    },
    {
      attributeName: 'startTime',
      label: 'Start Time',
      type: FormInputTypes.TIMESTAMP,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'The date that the task was started.',
    },
    {
      attributeName: 'endTime',
      label: 'End Time',
      type: FormInputTypes.TIMESTAMP,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'The date that the task was finished.',
    },
    {
      attributeName: 'elapsedTime',
      label: 'Elapsed Time',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'Elapsed time from the start to end.',
    },
    {
      attributeName: 'baseName',
      label: 'Base Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the file of the task.',
    },
    {
      attributeName: 'message',
      label: 'Message',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'Information of the task.',
    },
  ],
};
